<app-si-dialog header="Export Companies to {{crmType | titlecase}}" #siDialogComponent>
	<ng-template appDialogBody>
		<div class="px-6" [formGroup]="form">
			<ng-container *ngIf="!(isLoading$ | async); else loadingTpl">
				<ng-container [ngSwitch]="pages[currentPageIndex]">
					<ng-container *ngSwitchCase="pageType.DUPLICATES">
						<div class="flex flex-wrap -mx-2 gap-0 py-6">
							<div class="flex-none w-full px-2">
								<h3>Duplicates</h3>
								<p>Resolve Duplicates by:</p>
								<app-duplicate-resolution-radio-group formControlName="duplicateResolution"></app-duplicate-resolution-radio-group>
							</div>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageType.JOB_TITLE">
						<div class="flex flex-wrap -mx-2 gap-0 py-12">
							<div class="flex-none w-full px-2">
								<mat-form-field appearance="outline" class="mb-2 w-full">
									<mat-label>Job Name (optional)</mat-label>
									<input matInput type="text" formControlName="label" placeholder="Job Name">
								</mat-form-field>
							</div>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageType.FINISHED">
						<div class="flex flex-wrap -mx-2 gap-0 py-12">
							<div class="flex-none w-2/3 ml-[16.666667%] px-2">
								<p>Due to the size of your request, you will receive an email when your export is ready. This may take 30 minutes or more during busy times.</p>
							</div>
						</div>
					</ng-container>
				</ng-container>

			</ng-container>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<div>
			<button *ngIf="pages[currentPageIndex] !== pageType.FINISHED" matButton="outlined" type="button" (click)="siDialogComponent.onClose()">Cancel</button>
		</div>


		<button
			*ngIf="pages[currentPageIndex] === pageType.FINISHED"
      matButton="outlined"
			type="button"
			(click)="siDialogComponent.onClose()">Close</button>

		<ng-container *ngIf="pages[currentPageIndex] !== pageType.FINISHED">
			<div>
				<button
					*ngIf="currentPageIndex !== 0 && showPreviousButton"
					matButton="filled"
					type="button"
					class="ml-2"
					[disabled]="isLoading$ | async"
					(click)="previous()"
				>Previous</button>
				<button
					*ngIf="pages[currentPageIndex] === pageType.JOB_TITLE"
					matButton="filled"
					type="button"
					class="ml-2"
					[disabled]="isLoading$ | async"
					(click)="export()"
				>Export</button>
				<button
					*ngIf="pages[currentPageIndex] !== pageType.JOB_TITLE"
					matButton="filled"
					type="button"
					class="ml-2"
					[disabled]="isLoading$ | async"
					(click)="next()"
				>Next</button>
			</div>
		</ng-container>
	</ng-template>
</app-si-dialog>

<ng-template #loadingTpl>
	<div class="h-full flex justify-center items-center py-12">
		<mat-spinner></mat-spinner>
	</div>
</ng-template>
